export function colorLuminance(
  hex: string,
  lum: number,
  lumType?: 'offset'
): string {
  // validate hex string
  let hexString = String(hex).replace(/[^0-9a-f]/gi, '');
  if (hexString.length < 6) {
    hexString =
      hexString[0] +
      hexString[0] +
      hexString[1] +
      hexString[1] +
      hexString[2] +
      hexString[2];
  }
  const lumVal = lum || 0;

  // convert to decimal and change luminosity
  let rgb = '#';
  let c;
  let i;
  for (i = 0; i < 3; i += 1) {
    c = parseInt(hexString.substr(i * 2, 2), 16);
    const offset = lumType === 'offset' ? lumVal : lumVal * c;
    c = Math.round(Math.min(Math.max(0, c + offset), 255)).toString(16);
    rgb += `00${c}`.substr(c.length);
  }

  return rgb;
}

/**
 * Converts hex values to RGB value string
 * Ex. '#ffffff' => 'rgb(255, 255, 255)'
 */
export function hexToRgb(hex: string, alpha?: number): string | null {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (!result) return null;

  let rgb: string;

  if (alpha) {
    rgb = `rgba(${parseInt(result[1], 16)}, ${parseInt(
      result[2],
      16
    )}, ${parseInt(result[3], 16)}, ${alpha})`;
  } else {
    rgb = `rgb(${parseInt(result[1], 16)}, ${parseInt(
      result[2],
      16
    )}, ${parseInt(result[3], 16)}`;
  }

  return rgb;
}

/**
 * Returns true if given color requires lighter text for readability;
 * @example if dark color (like black #000000) is given, `true` is returned to
 * signify that text color should be a light color (like white #ffffff).
 * @param hex - color code to check; including '#' is optional
 */
export function checkContrast(hex: string): boolean {
  const color = hex.startsWith('#') ? hex.slice(1) : hex;
  const r = parseInt(color.substr(0, 2), 16);
  const g = parseInt(color.substr(2, 2), 16);
  const b = parseInt(color.substr(4, 2), 16);
  const yiq = (r * 299 + g * 587 + b * 114) / 1000;
  return yiq >= 128;
}
